export default (/* store */) => {

};



// WEBPACK FOOTER //
// ./src/store/mock.js